import { EditorState } from 'lexical';

export type ContactTypingInfo = {
  contactId: string;
  isTyping: boolean;
};

export type AgentMessage = {
  selectedChat: string | null;
  state: EditorState;
};

export type DefaultCallActionState = { customer: boolean; thirdParty: boolean };
export const defaultCallActionStateValue = { customer: false, thirdParty: false };
